<template>
  <v-dialog v-model="edit" max-width="300">
    <v-card>
      <v-card-title>
        <v-icon left>mdi-pencil</v-icon>
        <span class="title font-weight-light">Edit Geofence</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="geofence.name" label="Geofence name*" required></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="geofence.options">
            <v-col cols="12">
              <v-color-picker v-model="geofence.options.color" mode="hexa" width="230" hide-mode-switch flat light></v-color-picker>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined @click="cancel()">Cancel</v-btn>
        <v-btn color="primary" outlined @click="save()">Save</v-btn>
        
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    geofenceBeforeEdit: {}
  }),
  /*data() {
    return {
      loading: false,
      expandedMember: this.expanded
    };
  },*/
  created() {},
  mounted() {},
  computed: {},
  methods: {
    save() {
      this.geofence.save();
      this.$emit("update:edit", false);
    },
    cancel() {
      Object.assign(this.geofence, this.geofenceBeforeEdit);
      this.$emit("update:edit", false);
    }
  },
  watch: {
    edit(open) {
      if (open) {
        this.geofenceBeforeEdit = Object.assign({}, this.geofence);
      }
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    geofence: {
      type: Object
    },
    callback: {
      type: Function,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
</style>